// extracted by mini-css-extract-plugin
module.exports = {"people-container":"people_people-container__FJ54t","header":"people_header__Exlhq"};